export default __webpack_public_path__ + "static/media/dummy.71cbae38.png";